import { useRef } from 'react';

const useTokensList = () => {
  const tokens = useRef<string[]>([]);
  const pointer = useRef<number>(0);
  const noMore = useRef<boolean>(false);

  const addTokenToEnd = (token: string) => {
    tokens.current = tokens.current.concat(token);
  };

  const addTokenToBeginning = (token: string) => {
    tokens.current = [token].concat(tokens.current);
  };

  const setNoMore = () => {
    noMore.current = true;
  };

  const moveRight = (): string | undefined => {
    const index = pointer.current + 1;
    if (index >= tokens.current.length) {
      if (noMore.current) {
        pointer.current = 0;
        return tokens.current[0];
      } else {
        pointer.current = index;
        return undefined;
      }
    }
    pointer.current = index;
    return tokens.current[index];
  };

  const moveLeft = (): string | undefined => {
    const index = pointer.current - 1;
    if (index < 0) {
      if (noMore.current) {
        pointer.current = tokens.current.length - 1;
        return tokens.current[pointer.current];
      } else {
        pointer.current = 0;
        return undefined;
      }
    }
    pointer.current = index;
    return tokens.current[index];
  };

  const getFetched = () => {
    return tokens.current;
  };

  return {
    moveRight,
    moveLeft,
    setNoMore,
    addTokenToEnd,
    addTokenToBeginning,
    getFetched
  };
};

export default useTokensList;
